export { onCreateApp };
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query';
const onCreateApp = (pageContext) => {
    installVueQuery(pageContext);
};
function installVueQuery(pageContext) {
    const queryClient = new QueryClient(pageContext.config.queryClientConfig);
    pageContext.app.use(VueQueryPlugin, { queryClient });
    Object.assign(pageContext, { queryClient });
}
